import {$window} from '../utils/globals'

/**
 * Handle Animation
 */
const handleTemplatesAnimation = () => {
	const $container = $('.js-templates-animation');
	
	if (! $container.length > 0) {
		return;
	}

	$window.on('scroll load', () => {
		const scroll = $window.scrollTop();
		const isActivate = $container.hasClass('is-active')
		const startAnimationTrigger = $container.offset().top < scroll + $window.innerHeight();

		if (startAnimationTrigger && !isActivate) {
			$container.addClass('is-active')
			startAnimation();
		}
	});
}

/**
 * Start Animation
 */
const startAnimation = () => {

	const $container = $('.js-templates-animation');
		
	$container.on('update:button-hover', () => {
		const buttonHover = setTimeout(() => {
			activeButtonHover($container);
			
			clearTimeout(buttonHover);
		}, 500);

	}).on('update:open-images', () => {
		const openImages =  setTimeout(() => {
			openImagesTab($container)
			
			clearTimeout(openImages);
		}, 1200);

	}).on('update:selection-of-photos', () => {
		const selectionOfPhotos = setTimeout(() => {
			moveCurrsorToImage($container)
			
			clearTimeout(selectionOfPhotos);
		}, 100);

	}).on('update:click-image', () => {
		const clickImage = setTimeout(() => {

			moveSelectedImageUp($container);
			
			clearTimeout(clickImage);
		}, 1500);

	}).on('update:selected', () => {
		const selectedUpdate = setTimeout(() => {
			selectImage($container)
			
			clearTimeout(selectedUpdate);
		}, 600);

	}).on('update:start-video', () => {
		const startVideoTimeOut = setTimeout(() => {
			startVideo($container);
			
			clearTimeout(startVideoTimeOut);
		}, 500);

	}).on('update:video-end', () => {
		resetAnimation($container);
	});

	moveCurrsorToButton($container);
}

/**
 * Move cursor to button
 */
const moveCurrsorToButton = ($container) => {

	$container.each(function(index, el) {
		const $element = $(el);
		const $cursor = $element.find('.templates-animation__cursor');
		const $tooltip = $element.find('.templates-animation__tooltip');

		$container.addClass('is-playing');

		$cursor.addClass('hover-button');

		const timeOutToolTip = setTimeout(() => {
			$tooltip.addClass('is-visible');
			
			clearTimeout(timeOutToolTip);
		}, 600);

		const timeOutCursor = setTimeout(() => {
			$cursor.addClass('is-click');
			
			clearTimeout(timeOutCursor);
		}, 400);

		const timeOutCoursorRemove = setTimeout(() => {
			$cursor.removeClass('is-click');
			clearTimeout(timeOutCoursorRemove);
		}, 800);

		$container.trigger('update:button-hover');
	});
}

/**
 * Active Button hover
 */
const activeButtonHover = ($container) => {

	$container.each(function(index, el) {
		const $element = $(el);
		const $buttonHover = $element.find('.templates-animation__ico--hover');

		$buttonHover.addClass('is-visible');

		$container.trigger('update:open-images');
	});
}

/**
 * Open image list
 */
const openImagesTab = ($container) => {

	$container.each(function(index, el) {
		const $element = $(el);
		const $listImages = $element.find('.list-of-images');
		const $cursor = $element.find('.templates-animation__cursor');
		const $tooltip = $element.find('.templates-animation__tooltip');

		$cursor.removeClass('is-click remove-click');
		$tooltip.removeClass('is-visible');


		$listImages.addClass('is-visible')		
	});

	$container.trigger('update:selection-of-photos');
}

/**
 * Move cursor to button
 */
const moveCurrsorToImage = ($container) => {

	$container.each(function(index, el) {
		const $element = $(el);
		const $cursor = $element.find('.templates-animation__cursor');

		$cursor.addClass('hover-image');

		setTimeout(() => {
			$cursor.addClass('is-click');
		}, 400);

		setTimeout(() => {
			$cursor.removeClass('is-click');
		}, 800);

		$container.trigger('update:click-image');
	});
}

const moveSelectedImageUp = ($container) => {
	$container.each(function(index, el) {
		const $element = $(el);
		const $buttonHover = $element.find('.templates-animation__ico--hover');
		const $button = $element.find('.templates-animation__ico');

		$button.addClass('hidden');
		$buttonHover.addClass('hidden');
		$element.addClass('move-up');
		$container.trigger('update:selected');
	});
}

/**
 * Select image
 */
const selectImage = ($container) => {
	$container.each(function(index, el) {
		const $element = $(el);
		const $cursor = $element.find('.templates-animation__cursor');
		const $listImages = $element.find('.list-of-images');

		$cursor.addClass('is-hidden');
		$listImages.addClass('is-selected')
		$element.addClass('is-selected');

		setTimeout(() => {
			$element.addClass('show-empty');
		}, 100);

		$container.trigger('update:start-video');
	});
}

const startVideo = ($container) => {
	$container.each(function(index, el) {
		const $element = $(el);
		const $video = $element.find('.js-video-templates');
		const src = $video.attr('data-src');

		$video.find('source').attr({
			'src': `${src}`,
		});

		$video.find('video')[0].load();

		$video.find('video').get(0).play();

		$video.find('video').on("ended", function() {
			$container.trigger('update:video-end');
		});

		$video.addClass("is-visible");
	});
}

/**
 * Reset animation and play again
 */
const resetAnimation = ($container) => {
	$container
		.off('update:button-hover')
		.off('update:open-images')
		.off('update:selection-of-photos')
		.off('update:click-image')
		.off('update:selected')
		.off('update:start-video')
		.off('update:video-end')

	$container.each(function(index, el) {
		const $element = $(el);
		const $cursor = $element.find('.templates-animation__cursor');
		const $listImages = $element.find('.list-of-images');
		const $video = $element.find('.js-video-templates');
		const $buttonHover = $element.find('.templates-animation__ico--hover');
		const $button = $element.find('.templates-animation__ico');

		$cursor.removeClass('is-hidden hover-image hover-button is-click');
		$listImages.removeClass('is-selected is-visible');
		$element.removeClass('is-selected show-empty move-up');
		$buttonHover.removeClass('is-visible hidden');
		$button.removeClass('hidden');

		$video.removeClass("is-visible");
	});

	setTimeout(() => {
		startAnimation()
	}, 500);
}

handleTemplatesAnimation();
